import * as Joi from "joi";
import { Moment } from 'moment';
import { Column, PrimaryGeneratedColumn } from 'typeorm';
import { GenPartial, momentTransformer } from 'typeormgen';
import Notable from '../notable';
import ProdBase from '../prod-base.entity';

export default abstract class SceneNoteBase
	extends ProdBase
	implements Notable {
	static skipUpdateColumns = [
		'id',
		'mobile_id',
		'prod_id',
		'date_created',
		'created_by',
		'last_updated_user',
		'last_updated_time',
	];

	@PrimaryGeneratedColumn()
	id: number;

	@Column('varchar')
	mobile_id: string;

	@Column('int')
	prod_id: number;

	@Column('int')
	scene_id: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	@Column('int')
	last_updated_user: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	@Column('int')
	created_by: number;

	static rules() {
		return {
			id: Joi.number().integer(),
			mobile_id: Joi.string().max(36).allow(null, ''),
			prod_id: Joi.number().integer(),
			scene_id: Joi.number().integer(),
			last_updated_time: Joi.date().allow(null),
			last_updated_user: Joi.number().integer(),
			date_created: Joi.date().allow(null),
			created_by: Joi.number().integer(),
		};
	}

	toJSON() {
		return {
			id: this.id,
			mobile_id: this.mobile_id,
			prod_id: this.prod_id,
			scene_id: this.scene_id,
			last_updated_time: this.last_updated_time,
			last_updated_user: this.last_updated_user,
			date_created: this.date_created,
			created_by: this.created_by,
		};
	}

	assign(props?: GenPartial<SceneNoteBase>) {
		super.assign(props);

		if (props) {
			this.last_updated_time = momentTransformer.from(props.last_updated_time);
			this.date_created = momentTransformer.from(props.date_created);
		}
	}

	constructor(props?: GenPartial<SceneNoteBase>) {
		super(props);
	}

	abstract get note();
	abstract set note(note: string);
}
